<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.2566 4.38677C13.8252 3.65116 13.0396 3.19679 12.1878 3.18978C11.3351 3.18277 10.5414 3.62414 10.0991 4.35275C8.08139 7.67051 4.39733 13.7296 2.33362 17.1244C1.87824 17.872 1.86223 18.8068 2.29159 19.5694C2.71995 20.3321 3.5266 20.8034 4.40233 20.8034H19.652C20.5198 20.8034 21.3214 20.3391 21.7528 19.5864C22.1842 18.8338 22.1802 17.907 21.7408 17.1584L14.2566 4.38677ZM12.8894 5.18744L20.3736 17.9591C20.5258 18.2183 20.5268 18.5386 20.3776 18.7988C20.2285 19.059 19.9523 19.2191 19.652 19.2191C15.6577 19.2191 8.42468 19.2191 4.40233 19.2191C4.10008 19.2191 3.82086 19.056 3.67274 18.7928C3.52462 18.5286 3.5306 18.2063 3.68674 17.9481C3.68674 17.9481 11.4522 5.17743 11.4532 5.17543C11.6063 4.92422 11.8796 4.77109 12.1748 4.7741C12.4691 4.7761 12.7403 4.93323 12.8894 5.18744ZM11.0899 16.9322C11.0899 17.4727 11.5333 17.851 12.0737 17.851C12.6212 17.851 13.0645 17.4727 13.0645 16.9322C13.0645 16.3908 12.6212 16.0125 12.0737 16.0125C11.5333 16.0125 11.0899 16.3908 11.0899 16.9322ZM11.2981 14.0828C11.3111 14.5072 11.6504 14.8265 12.0807 14.8265C12.4981 14.8265 12.8304 14.5202 12.8494 14.0828L13.0065 9.48703C13.0255 8.9786 12.6212 8.56825 12.0807 8.56825C11.5393 8.56825 11.142 8.9786 11.161 9.48703L11.2981 14.0828Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'Warning'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
